import { useSelector } from 'react-redux';

import useUploadForm from 'app/hooks/useUploadForm';

import {
  updateMoment
} from 'app/services/moments';

import {
  MOMENT_UPLOAD_URL
} from 'app/utils/Constants';

const useMomentReplaceUploadForm = props => {
  const {
    moment,
    onUploadComplete
  } = props;

  const createFileContexts = async params => {
    // the original file objects shouldn't be altered
    const file = params.files[0];

    let fileContexts = [{
      id: moment.id,
      uploadUrlEndpoint: MOMENT_UPLOAD_URL(moment.id, file.type, true)
    }]

    return fileContexts;
  }

  const onFileComplete = async () => {
    // bump updatedAt and uploaded timestamps
    let updatedMoment = await updateMoment(moment.id, { uploaded: 'true' });

    if (onUploadComplete) {
      onUploadComplete(updatedMoment);
    }
  }

  const {
    formIsOpen,
    onFormClose,
    onFormSubmit,
    onAdd,
  } = useUploadForm({
    createFileContexts,
    onFileComplete
  });

  return {
    formIsOpen,
    onAdd,
    onFormClose,
    onFormSubmit
  }
}

export default useMomentReplaceUploadForm;
